<template>
  <Layout v-if="state$$.isVisible">
    <template #body>
      <Card :title="`Confirmar datos`">
        <template #body>
          <section>
            <Steppy
              v-model:step="stepRef"
              :tabs="isTutorizeMode ? [
                {
                  title: 'Tutor',
                  iconSuccess: null,
                  isValid: true,
                },
                {
                  title: 'Menor',
                  iconSuccess: null,
                  isValid: true,
                },
                {
                  title: 'Contacto',
                  iconSuccess: null,
                  isValid: true,
                },
                {
                  title: 'Confirmación',
                  iconSuccess: null,
                  isValid: true,
                },
              ] : [
                {
                  title: 'Datos',
                  iconSuccess: null,
                  isValid: true,
                },
                {
                  title: 'Contacto',
                  iconSuccess: null,
                  isValid: true,
                },
                {
                  title: 'Confirmación',
                  iconSuccess: null,
                  isValid: true,
                },
              ]"
              class="wrapper__steppy"
              :primary-color1="primaryColor"
            >
            </Steppy>
            <div class="register-list__box">
              <div
                v-if="state$$.registerTutorList"
                class=""
              >
                <h2>Tutor</h2>
                <ul class="register-list__box__list">
                  <AcceptedRequestItem
                    v-for="item in state$$.registerTutorList"
                    :key="item"
                    :label="item.label"
                    :value="item.value"
                  />
                </ul>
              </div>
              <div>
                <h2 v-if="state$$.registerTutorList">
                  Menor
                </h2>
                <ul class="register-list__box__list">
                  <AcceptedRequestItem
                    v-for="item in state$$.registerList"
                    :key="item"
                    :label="item.label"
                    :value="item.value"
                  />
                </ul>
              </div>
            </div>
            <p
              v-if="appState$$?.currentRequest?.serverDate"
              class="register-list-date-print"
            >
              <span>Fecha de registro:</span>
              <span>
                {{ registerDate(appState$$?.currentRequest?.serverDate) }}
              </span>
            </p>
          </section>
          <div class="keypad noprint">
            <Button
              class="bttn-AJ keypad__btn p-button-secondary"
              label="Volver"
              tabindex="0"
              @click="router.push({name: REGISTER_ROUTE_NAME});"
              @keyup.enter="router.push({name: REGISTER_ROUTE_NAME});"
            />
            <Button
              class="bttn-AJ keypad__btn keypad__icon p-button-secondary"
              label="Imprimir"
              icon="pi pi-print"
              tabindex="0"
              @click="printForm"
              @keyup.enter="printForm"
            />
            <Button
              class="bttn-AJ keypad__btn keypad__btn--primary"
              label="Confirmar"
              tabindex="0"
              @click="callPreRegister"
              @keyup.enter="callPreRegister"
            />
          </div>
        </template>
      </Card>
    </template>
  </Layout>
</template>

<script setup>
// #region Vue
import {
  inject,
  onMounted,
  reactive,
  onBeforeUnmount,
  computed,
  ref,
} from 'vue';
// #endregion

// #region Sttedra
import {
  // useDev,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

// #region Components
import Layout from '@/components/layout/Layout.vue';
import Card from '@/components/card/Card.vue';
import Button from 'primevue/button/sfc';
import {Steppy} from 'vue3-steppy';
import AcceptedRequestItem from './AcceptedRequestItem.vue';

// #endregion

// #region API
import {StatusCodes as HttpStatus} from 'http-status-codes';

import {
  preRegister as preRegisterApi,
} from '@/api/register/register.api';
// #endregion

// #region Composables
import useTransformToTimestampString from '@/composables/transform-timestamp-string';
import {useStore} from 'vuex';
import {useRouter} from 'vue-router';
import useManageApiError from '@/composables/manage-api-error';
import useThemeChange from '@/composables/use-theme-change';
import useHelpers from '@/composables/helpers';
// #endregion

// #region MODELS AND STATE
import AcceptedRequestViewState from './accepted-request.view-state';
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const router = useRouter();
const store = useStore();
const appState$$ = inject('appState$$');
const {primaryColor} = useThemeChange();
const {
  showErrorToast,
} = useManageApiError();

const isTutorizeMode = computed(() => store.getters['register/isTutorizeMode']);
const {transformTimestampStringNotDate} = useTransformToTimestampString();
const {getMadridUtcOffsetHours} = useHelpers();

const stepRef = ref(isTutorizeMode.value ? 4 : 3);
const REGISTER_ROUTE_NAME = isTutorizeMode.value ? 'RegisterTutorize' : 'Register';

// appState$$.currentRequest = {
//   'identificationNumber': '77153489N',
//   'validDateDNI': '2001-11-10T23:00:00.000Z',
//   'supportNumber': null,
//   'name': 'ADRIAN',
//   'surname': 'QUESADA',
//   'secondSurname': 'LOPEZ',
//   'birthDate': '2001-11-10T23:00:00.000Z',
//   'countryEU': 5,
//   'checkPrivacyPolicy': true,
//   'email': 'A@A.COM',
//   'emailValidation': 'A@A.COM',
//   'phone': '+34652652652',
//   'code': '26A32EE9397B1BB863EA',
//   'stateId': 3,
//   'validationType': 'Online',
//   'stateCode': '02',
//   'serverDate': '2023-06-05T15:18:07.77624',
//   'temporalToken': null,
// };

const isLogged = appState$$.isLogged;
const state = new AcceptedRequestViewState(appState$$?.currentRequest, appState$$?.countryEU, isLogged);
const state$$ = reactive(state);
const {getObjectFilled} = useNormalizer();
// #endregion

// #region Functions
function printForm() {
  window.print();
}

async function callPreRegister() {
  appState$$.setLoginApp(true);

  const temporalToken = appState$$.currentRequest.temporalToken;

  const {response} = await preRegisterApi(
    appState$$.currentRequest,
    temporalToken,
  );

  if (response?.status === HttpStatus.OK) {
    const data = response?.data;
    appState$$.currentRequest = {
      ...appState$$.currentRequest,
      ...data,
    };

    appState$$.setLoginApp(false);
    router.push({name: `PendingRequest`});
  } else {
    showErrorToast(`Ocurrió un error al intentar finalizar el registro.\n 
        Por favor, inténtelo de nuevo más tarde.\n
        Disculpe las molestias.`);

    appState$$.currentRequest = null;
    appState$$.setLoginApp(false);
    router.push({name: REGISTER_ROUTE_NAME});
  }
}

function registerDate(dateString) {
  const date = transformTimestampStringNotDate(dateString);
  const offset = getMadridUtcOffsetHours(dateString);

  if (offset === 1) {
    return `${date} (CET - GMT+1)`;
  }
  if (offset === 2) {
    return `${date} (CEST - GMT+2)`;
  }
  return `${date}`;
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  state$$.isVisible = false;

  if (appState$$.isOffline || !getObjectFilled(appState$$.currentRequest)) {
    appState$$.setLoginApp(true);
    router.push({name: `Home`});
    return;
  }

  appState$$.setLoginApp(false);
  state$$.isVisible = true;
});

onBeforeUnmount(() => {
  state$$.isVisible = false;
});
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>

@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.register-list{
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 250px;
  &__box{
    display: flex;
    gap: 1rem;
    margin-top: 4rem;
    @media print {
      margin-top: 0rem;
      h2{
        font-size: 1rem;
        margin-bottom: 4px;
      }
    }
  &__list{
    margin-top:2rem;
    padding: 0;
    @media print {
      margin: 0px !important;
    }
  }
  }
}

.keypad{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: $brand__boxspace--medium;
  margin-top: $brand__boxspace--medium;

  &__btn{
    &--primary{
      background-color: var(--primary-800);
    }
  }

  @include media("<=phone") {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
      gap: $brand__boxspace--medium * 2;
      &__btn{
        min-width: 200px;
      }
    }

    @include media(">tablet") {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    }

    @media print {
      display: none !important;
    }

  &__icon{
    font-size: 1.5rem;
  }
}

.register-list-date-print{
  display: none;
  @media print {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 2rem;
    gap: 0.5rem;
  }
  &:first-child{
    font-weight: bold;
  }
}

</style>
